import { BsArrowLeft } from "react-icons/bs";
import { RiArrowRightSLine } from "react-icons/ri";
import img1 from '../../../Assets/case_3.png'
import img2 from '../../../Assets/case_3_1.png'
import img3 from '../../../Assets/case_3_2.png'
import avatar from '../../../Assets/avatar_teste.png'
import * as S from './styles';

export const Ecosalva = () => {
  return (
    <S.Wrapper>

      <S.HeaderBar>
        <S.BackButton
          onClick={() => window.history.back()} aria-label="Voltar"
        >
          <BsArrowLeft size={40} />
        </S.BackButton>
        <h2>Ecosalva</h2>
      </S.HeaderBar>

      <S.Grid>
        <S.Sidebar>
          <S.SideBlock>

            <S.SideTitle>
              Overview
            </S.SideTitle>

            <p>
              A EccoSalva enfrentava o desafio de garantir uma comunicação rápida, precisa e segura entre equipes médicas e socorristas durante os atendimentos de emergência.
              Buscando aprimorar a eficiência operacional e reduzir falhas na troca de informações, a Bindflow desenvolveu um aplicativo exclusivo que conecta profissionais em campo à central médica em tempo real.
            </p>

            <p>
              Com essa solução, médicos e socorristas podem compartilhar dados, vídeo e áudio instantaneamente, garantindo diagnósticos mais ágeis e decisões assertivas.
              O resultado é um atendimento mais completo, humano e tecnológico, que salva vidas e fortalece o compromisso da EccoSalva com a excelência em emergências médicas.
            </p>

          </S.SideBlock>

          <S.SideBlock>
            <S.SideTitle>Entregáveis</S.SideTitle>
            <ul>
              <li><p>Aplicativo móvel integrado entre central médica e socorristas.</p></li>
              <li><p>Comunicação em tempo real com áudio, vídeo e prontuário digital.</p></li>
              <li><p>Dashboard administrativo para monitoramento de atendimentos.</p></li>
              <li><p>Armazenamento seguro e criptografado de dados médicos.</p></li>
              <li><p>Integração com sistemas hospitalares e de emergência.</p></li>
              <li><p>Maior agilidade e eficiência nas decisões em campo.</p></li>
            </ul>
          </S.SideBlock>
        </S.Sidebar>

        <S.Main>
          <S.Img src={img1} alt="Hero" />

          <S.TwoCol>
            <S.Img src={img2} alt="" />
            <S.Img src={img3} alt="" />
          </S.TwoCol>

        </S.Main>
      </S.Grid>
    </S.Wrapper >
  );
};
